import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const isAuthRoute = window.location.pathname === '/login' || window.location.pathname === '/';

    if (status === 401 && !isAuthRoute) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    } else if (status === 403) {
      toast.error('Acesso negado. Você não tem permissão para esta ação.');
    }

    return Promise.reject(error);
  }
);


export const getAttachments = async (transactionId) => {
    const res = await api.get(`/transactions/${transactionId}/attachments`);
    return res.data;
};

export const uploadAttachment = async (transactionId, file) => {
    const formData = new FormData();
    formData.append('file', file);
    // NÃO definir Content-Type manualmente — o browser precisa setar o boundary automaticamente
    const res = await api.post(`/transactions/${transactionId}/attachments`, formData);
    return res.data;
};

export const deleteAttachment = async (transactionId, attachmentId) => {
    const res = await api.delete(`/transactions/${transactionId}/attachments/${attachmentId}`);
    return res.data;
};

export const downloadAttachment = async (transactionId, attachmentId) => {
    // O backend redireciona para uma URL pré-assinada do B2 (válida 5 min)
    const token = localStorage.getItem('token');
    const response = await fetch(
        `${process.env.REACT_APP_API_URL}/transactions/${transactionId}/attachments/${attachmentId}/download`,
        { headers: { Authorization: `Bearer ${token}` }, redirect: 'follow' }
    );
    if (!response.ok) throw new Error('Erro ao baixar arquivo');
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.click();
    URL.revokeObjectURL(url);
};

export const importOFX = async (file) => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${process.env.REACT_APP_API_URL}/transactions/import/ofx`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
            // NÃO coloque 'Content-Type': 'multipart/form-data' aqui!
        },
        body: formData
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Erro ao importar arquivo');
    }
    return response.json();
};

export default api;